import { useQuery } from '@tanstack/react-query';

import { disbursementService } from '../services/disbursement.service';

export const useDisbursementStats = () => {
  return useQuery({
    queryKey: ['disbursement-stats'],
    queryFn: () => disbursementService.getDisbursementStats()
  });
};
